/* Maison Byōbu · ajouts de la fiche de vente (sections/mb-ideal-fiche-ajouts.liquid, 24/10/2026, agent B).
   Affichage seulement. Les montants sont ceux du moteur <mb-cadreur> (assets/mb-cadreur.js, calcul jamais modifié) :
   tarifImprime(L, H, prix au m²), promotion comprise (enveloppe d'assets/mb-offre.js), lus exactement comme
   assets/mb-sig-oeuvre.js lit ceux des formats et des matières (prix au m² = le moteur sur 2 m², divisé par deux).
   - prix au m² de la matière cochée, puis l'exemple de mur entier (data-ex-l × data-ex-h) ;
   - délai (24/10) : la phrase « Livré sous … jours après votre accord sur le plan » est écrite par la section (plus de
     date) ; la ligne « Livré sous … jours » du pied du récapitulatif, qui dirait presque la même chose, est masquée ;
   - motifs raccordés : la mosaïque suit le mur imprimé du moteur (imp), au raccord du moteur (raccord, en cm). */
(() => {
  const d = document;
  const r = d.querySelector('[data-mb-sig-oeuvre]');
  const s = d.querySelector('[data-mb-ideal-fiche]');
  if (!r || !s || s.dataset.pret) return;
  s.dataset.pret = 'oui';
  const EX = { l: parseInt(s.dataset.exL, 10) || 350, h: parseInt(s.dataset.exH, 10) || 250 };
  const $ = (sel) => r.querySelector(sel);

  const eur = (centimes) => {
    const v = centimes / 100;
    const e = Math.abs(v - Math.round(v)) < 0.005;
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: e ? 0 : 2, maximumFractionDigits: e ? 0 : 2 }).format(e ? Math.round(v) : v);
  };
  const deux = (v) => new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
  const metres = (l, h) => `${deux(l / 100)} × ${deux(h / 100)} m`;
  const centimesDe = (t) => { const n = parseFloat(String(t || '').replace(/[^\d,.-]/g, '').replace(',', '.')); return Number.isFinite(n) ? Math.round(n * 100) : null; };
  const lireTarif = (t, div = 1) => {
    if (!t || t.centimes == null) return null;
    const fin = centimesDe(t.prix);
    if (fin == null) return null;
    const avant = t.barre ? centimesDe(t.barre) : null;
    return { fin: Math.round(fin / div), avant: avant && avant > fin ? Math.round(avant / div) : null };
  };
  const montant = (p) => (p.avant ? `<s class="prix-barre">${eur(p.avant)}</s> <span class="prix-vert">${eur(p.fin)}</span>` : eur(p.fin));

  let c = null;
  const cochee = () => $('#sig-matieres .option[aria-checked="true"]') || $('#sig-matieres .option:not([disabled])');

  /* Prix au m² de la matière cochée, puis l'exemple de mur */
  function prix() {
    const b = cochee();
    if (!b) return;
    const mat = $('[data-ifc-mat]');
    if (mat && b.dataset.nom) mat.textContent = ` · ${b.dataset.nom}`;
    if (!c) return;
    const pm2 = (parseInt(b.dataset.prix, 10) || 0) / 100;
    if (!pm2) return;
    const auM2 = lireTarif(c.tarifImprime(200, 100, pm2), 2);
    const ex = lireTarif(c.tarifImprime(EX.l, EX.h, pm2));
    const elM2 = $('[data-ifc-m2]');
    const elEx = $('[data-ifc-ex]');
    if (elM2 && auM2) elM2.innerHTML = montant(auM2);
    if (elEx && ex) elEx.innerHTML = montant(ex);
  }

  /* Mosaïque des motifs raccordés : le mur imprimé du moteur, la tuile au raccord du moteur */
  function mosaique() {
    const mur = $('[data-ifc-mur]');
    if (!mur) return;
    const rc = (c && c.raccord) || parseFloat(mur.parentNode.dataset.raccord) || 0;
    let L = 360;
    let H = 250;
    if (c && c.imp && c.imp.w > 0 && c.imp.h > 0) { L = c.imp.w; H = c.imp.h; }
    mur.style.aspectRatio = `${L} / ${H}`;
    mur.style.width = `min(100%, ${Math.round((440 * L) / H)}px)`;
    if (rc) mur.style.backgroundSize = `${((rc / L) * 100).toFixed(3)}% auto`;
    const leg = $('[data-ifc-mur-legende]');
    const quoi = mur.parentNode.dataset.format === 'matiere' ? 'l’effet matière' : 'le motif raccordé';
    if (leg && rc) leg.textContent = `Votre mur, ${metres(L, H)} : ${quoi}, répété à l’échelle réelle. Un raccord mesure ${String(rc).replace('.', ',')} cm de large.`;
  }

  /* Délai (24/10, décision de Marcel : « 14 jours après votre accord », plus de date fixe). La phrase est dans la section ;
     ici, seulement : la ligne « Livré sous … jours » du pied du récapitulatif est masquée, pour ne pas dire deux fois le délai. */
  function delai() {
    if (!$('[data-ifc-delai]')) return;
    r.querySelectorAll('.recap .promesse li').forEach((li) => { if (/Livré sous/i.test(li.textContent)) li.style.display = 'none'; });
  }

  const tout = () => { prix(); mosaique(); };
  const plusTard = () => setTimeout(tout, 0);
  ['#sig-matieres', '#sig-formats'].forEach((sel) => { const el = $(sel); if (el) el.addEventListener('click', plusTard); });
  ['#sig-largeur', '#sig-hauteur'].forEach((sel) => { const el = $(sel); if (el) { el.addEventListener('input', plusTard); el.addEventListener('change', plusTard); } });
  const liste = $('#sig-matieres');
  if (liste && 'MutationObserver' in window) new MutationObserver(prix).observe(liste, { subtree: true, attributes: true, attributeFilter: ['aria-checked'] });

  function monter(el) {
    if (c) return;
    c = el;
    c.addEventListener('mb-cadreur:prix', plusTard);
    tout();
  }
  let essais = 0;
  const attendre = () => {
    const el = d.querySelector('mb-cadreur');
    if (el && el.el && el.el.prix && typeof el.tarifImprime === 'function') monter(el);
    else if (essais++ < 100) setTimeout(attendre, 100);
  };
  const demarrer = () => { if ('customElements' in window) customElements.whenDefined('mb-cadreur').then(() => setTimeout(attendre, 0)); };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  window.addEventListener('load', plusTard);

  delai();
  tout();
})();
